import api, { HeimsAxiosRequestConfig } from './api';
import {
  listOfflineQueueItems,
  markOfflineQueueItemFailed,
  removeOfflineQueueItem,
  updateOfflineQueueMeta,
} from './offlineQueue';

let isSyncing = false;

export async function syncOfflineQueue() {
  if (isSyncing || !navigator.onLine) {
    return;
  }

  isSyncing = true;
  updateOfflineQueueMeta({ lastAttemptAt: new Date().toISOString() });

  try {
    const items = await listOfflineQueueItems();

    let syncedAny = false;

    for (const item of items) {
      try {
        if (
          item.type === 'project-comment' ||
          item.type === 'time-clock-clock-in' ||
          item.type === 'time-clock-clock-out'
        ) {
          await api.request({
            method: item.method,
            url: item.url,
            data: item.body,
            skipAuthRedirect: true,
          } as HeimsAxiosRequestConfig);
          await removeOfflineQueueItem(item.id);
          updateOfflineQueueMeta({ lastSyncedAt: new Date().toISOString() });
          syncedAny = true;
          continue;
        }

        await markOfflineQueueItemFailed(item.id, `Unsupported offline action: ${item.type}`);
      } catch (error) {
        const message =
          (error as { response?: { data?: { error?: { message?: string } } }; message?: string })
            ?.response?.data?.error?.message ??
          (error as { message?: string })?.message ??
          'Sync failed.';
        await markOfflineQueueItemFailed(item.id, message);
      }
    }

    if (syncedAny) {
      window.dispatchEvent(new CustomEvent('heims:offline-sync-complete'));
    }
  } finally {
    isSyncing = false;
  }
}
